/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Person_Create_Project_UnavailableInputs */

const fr_person_create_project_unavailable = /** @type {(inputs: Person_Create_Project_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un projet sélectionné n’est plus actif ou n’appartient pas à ce client. Retirez-le et choisissez un projet dans la liste de ce client.`)
};

const en_person_create_project_unavailable = /** @type {(inputs: Person_Create_Project_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A selected project is no longer active or does not belong to this client. Remove it and choose a project from this client’s list.`)
};

/**
* | output |
* | --- |
* | "A selected project is no longer active or does not belong to this client. Remove it and choose a project from this client’s list." |
*
* @param {Person_Create_Project_UnavailableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const person_create_project_unavailable = /** @type {((inputs?: Person_Create_Project_UnavailableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Person_Create_Project_UnavailableInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_person_create_project_unavailable(inputs)
	return fr_person_create_project_unavailable(inputs)
});